import { useRef } from "react";
import { InPlaceTextEditor } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { useUpdateBoard } from "../../../data/mutations/boardMutations";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const TaskTypeHeaderBoardInformation = ({ board }) => {
  const { t } = useTranslation(["Boards"]);
  const queryClient = useQueryClient();

  const boardNameRef = useRef(null);

  const { mutate: updateBoard } = useUpdateBoard();
  const boardNameId = "dd_settings_board-settings_title-row_board-name-input";
  const boardDescriptionId =
    "dd_settings_board-settings_title-row_board-description-input";

  const onBoardChange = (args) => {
    let boardInformation = {
      Id: board.Id,
      Name: board.Name,
      Description: board.Description,
      Archived: board.Archived,
    };

    if (args.name === "BoardName") {
      if (board.Name == args.value) return;
      boardInformation.Name = args.value;
    } else {
      if (board.Description == args.value) return;
      boardInformation.Description = args.value;
    }

    updateBoard(
      { board: boardInformation },
      {
        onSuccess: () => {
          toast.success(t("Success"), {
            position: "bottom-left",
          });
          queryClient.invalidateQueries(["get-board", board.Id]);
        },
        onError: () => {},
      }
    );
  };

  const onValidation = (e) => {
    if (e.data.value == "Empty") {
      e.errorMessage = t("Required");
      return;
    } else if (e.data.value.length > 100) {
      e.errorMessage = t("MaxLength");
      return;
    } else onBoardChange(e.data);
  };

  return (
    <div>
      <div className="d-flex">
        <InPlaceTextEditor
          ref={boardNameRef}
          id={boardNameId}
          name="BoardName"
          value={board?.Name}
          validationRules={{
            BoardName: { required: true, maxLength: 100 },
          }}
          validating={onValidation}
        />
        {board?.Archived ? (
          <span className="archived-label">{t("Archived")}</span>
        ) : null}
      </div>
      <InPlaceTextEditor
        id={boardDescriptionId}
        name="BoardDescription"
        value={board?.Description}
        emptyText={t("EmptyDescription")}
        change={onBoardChange}
      />
    </div>
  );
};
